import React, { useEffect, useState } from 'react';
import { Edit } from '@material-ui/icons';
import { Link } from 'react-router-dom';

import {
  deleteRatingTemplates,
  getRatingTemplates,
} from '../../services/apiService';
import LoadingCircleIcon from '../../icons/LoadingCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import MyAccordion from '../../extras/custom/MyAccordion.jsx';
import ConfirmDialog from '../../extras/custom/ConfirmDialog';

const ListRatingTemplates = () => {
  const [ratingTemplates, setratingTemplates] = useState([]);
  const [errorMessage, seterrorMessage] = useState(null);

  const getTemplates = async () => {
    try {
      const templates = await getRatingTemplates();
      console.log(templates);
      setratingTemplates(templates);
    } catch (error) {
      console.error(error);
      seterrorMessage(
        'Fetching Rating Templates Failed!\n Please Try Again Later!!'
      );
    }
  };
  useEffect(() => {
    getTemplates();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteRatingTemplates({ id });
      getTemplates();
    } catch (error) {
      console.log(error);
      console.error(error);
      seterrorMessage(
        'Deleted Rating Templates Failed!\n Please Try Again Later!!'
      );
    }
  };

  return (
    <div>
      <div className='flex gap-8 items-center'>
        <h1 className='user-heading text-3xl font-semibold'>Rating Template</h1>
        <Link
          to='/new-rating-template'
          className='bg-white border border-blue-c1 text-blue-c1 rounded-md px-3 py-1'
        >
          Add New
        </Link>
      </div>
      <div className='bg-white p-8 mt-8'>
        <div className='grid gap-4 grid-cols-2'>
          {ratingTemplates.length ? (
            ratingTemplates.map((template) => (
              <div
                key={template.id}
                className='border border-black border-opacity-20 rounded-lg px-5 py-4'
              >
                <div className='flex justify-between'>
                  <div>
                    <h1 className='uppercase text-xl font-semibold opacity-60'>
                      {template.title}
                    </h1>
                    <p className='text-sm font-mediu opacity-40'>
                      Rating ID: {template.id}
                    </p>
                  </div>
                  <Link
                    to={{
                      pathname: '/new-rating-template',
                      state: template,
                    }}
                    className='font-medium opacity-40 flex gap-1'
                  >
                    <Edit />
                  </Link>
                  <MyAccordion
                    trigger={
                      <DeleteIcon className='text-red-c1 cursor-pointer' />
                    }
                    component={
                      <ConfirmDialog accept={() => handleDelete(template.id)} />
                    }
                  />
                </div>

                <div className='mt-4'>
                  {template.parameters.map((param, i) => (
                    <h2 key={i} className='mt-1.5 font-medium opacity-50'>
                      {param.name}
                    </h2>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className='text-center text-red-500 whitespace-pre-line col-span-2 w-full'>
              {errorMessage || (
                <LoadingCircleIcon iconStyle='w-16 text-blue-400' />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListRatingTemplates;
